import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-paycheck",
  "use": "icon-paycheck-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-paycheck\">\r\n<path d=\"M104.6,0H39.1c-6.5,0-11.9,4.4-13.6,10.3h72.4c5.9,0,10.7,4.8,10.7,10.7l0,0v94c5.9-1.7,10.2-7.1,10.2-13.6V14.2\r\n\tC118.8,6.4,112.5,0,104.6,0z M94.5,16.5H17.7c-4.7,0-8.6,3.8-8.6,8.6l0,0v94.4c0,4.7,3.8,8.6,8.6,8.6h0h76.8c4.7,0,8.6-3.8,8.6-8.6\r\n\tV25C103.1,20.3,99.3,16.5,94.5,16.5z M63.1,78H81c3.4,0,6,2.8,6.1,6.1c0.1,3.3-2.9,6.1-6.1,6.1H60.8v14.5c0,3.4-2.8,6-6.1,6.1\r\n\tc-3.3,0.2-6.1-2.9-6.1-6.1V90.3H28.1c-3.4,0-6-2.8-6.1-6.1c-0.1-3.3,2.9-6.1,6.1-6.1h20.4V66.9h-2.4l-17.9,0.1c-3.4,0-6-2.8-6.1-6.1\r\n\tc-0.1-3.3,2.9-6.1,6.1-6.1l6.5,0l7,0L29.2,43c-2.5-2.3-2.2-6.3,0-8.7c2.3-2.5,6.3-2.2,8.7,0l2.6,2.5L54.7,50l17.1-15.7\r\n\tc2.5-2.3,6.1-2.3,8.7,0c2.4,2.2,2.4,6.5,0,8.7l-2.7,2.4c-3.3,3-6.7,6.1-10,9.1l13.2,0c3.4,0,6,2.8,6.1,6.1c0.1,3.3-2.9,6.1-6.1,6.1\r\n\tl-6.5,0l-13.7,0V78H63.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/paycheck.svg
// module id = +Mec
// module chunks = 125